import { AnalyticsEvent, logAnalyticsEvent } from 'utils/analytics'
import { FC, ReactNode } from 'react'

import { Language } from 'translations/Language'
import { coerceLanguage } from 'utils/localization'
import { lightroomPluginDownloadLink } from 'constants/staticLinks'
import { useTranslation } from 'react-i18next'
import { useUserData } from 'components/contexts/UserDataContext'

/** The creative's stored language, or the site language before user data loads */
export const useGuideLanguage = (): Language => {
  const { i18n } = useTranslation()
  const { baseUserData } = useUserData()

  return coerceLanguage(baseUserData?.language ?? i18n.language)
}

/**
 * Plugin download link; every placement logs the download, so the event counts all of them.
 * @example <DownloadLink placement="cta">Download</DownloadLink>
 */
export const DownloadLink: FC<{ placement: 'hero' | 'cta' | 'install_step', className?: string, children: ReactNode }> = ({ placement, className, children }) => {
  const language = useGuideLanguage()

  return (
    <a
      className={className}
      href={lightroomPluginDownloadLink}
      onClick={() => logAnalyticsEvent(AnalyticsEvent.LIGHTROOM_PLUGIN_DOWNLOADED, { placement, language })}
    >
      {children}
    </a>
  )
}
